import Navigation from "@/components/Navigation";
import Footer from "@/components/Footer";
import ParticleBackground from "@/components/ParticleBackground";
import AIGrid from "@/components/AIGrid";
import { Card } from "@/components/ui/card";
import { motion } from "framer-motion";

const Terms = () => {
  return (
    <div className="min-h-screen flex flex-col bg-background relative overflow-hidden">
      <ParticleBackground />
      <AIGrid />
      <Navigation />

      <main className="flex-grow pt-32 pb-20 relative z-10">
        <div className="container mx-auto px-4">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="text-center mb-12"
          >
            <h1 className="text-4xl md:text-6xl font-bold tracking-tight mb-4">Terms of Service</h1>
            <p className="text-muted-foreground text-lg">Terms and conditions governing the use of our services</p>
          </motion.div>

          <Card className="p-8 glass-effect border-primary/30 max-w-4xl mx-auto">
            <div className="space-y-8 text-sm leading-relaxed text-muted-foreground">
              <section>
                <h2 className="text-xl font-semibold mb-4">1. Scope</h2>
                <p>
                  These terms and conditions apply to all contracts concluded via the website between the provider (hereinafter "we") and the customer, unless expressly agreed otherwise.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold mb-4">2. Vehicle Sale</h2>
                <p>
                  All offers presented on the website are subject to change and non-binding. A contract for the purchase of a vehicle only comes into effect upon written confirmation or the conclusion of a written purchase agreement.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold mb-4">3. Vehicle Purchase</h2>
                <p>
                  When a customer offers a vehicle via the form, this does not yet constitute a binding offer. We will contact you after reviewing the offer. A binding purchase will only take place after a personal inspection and a written agreement.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold mb-4">4. Prizes</h2>
                <p>
                  All prices are quoted in euros and include VAT unless otherwise stated.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold mb-4">5. Warranty</h2>
                <p>
                  Sales to consumers are subject to statutory warranty rights. Sales to businesses are made excluding any warranty, unless otherwise agreed.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold mb-4">6. Liability</h2>
                <p>
                  We are only liable for damages resulting from an intentional or grossly negligent breach of duty. In cases of slight negligence, we are only liable if a material contractual obligation (a so-called cardinal obligation) has been breached. In this case, liability is limited to foreseeable damages.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold mb-4">7. Data Protection</h2>
                <p>
                  Our privacy policy applies. Personal data will be used exclusively for processing your request and for fulfilling contracts.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold mb-4">8. Place of Jurisdiction</h2>
                <p>
                  If the customer is an entrepreneur or does not have a residence in the European Union, the place of jurisdiction is our company headquarters.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold mb-4">9. Final Provisions</h2>
                <p>
                  Should individual provisions of these terms and conditions be wholly or partially invalid, the validity of the remaining provisions shall remain unaffected.
                </p>
              </section>

              <div className="text-xs mt-8 pt-4 border-t border-muted">
                <p>Last updated: November 3, 2025</p>
              </div>
            </div>
          </Card>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default Terms;


